module.exports = __webpack_public_path__ + "static/media/project.39a0cdb3.jpg";